import { TypedDocumentNode, gql } from '@apollo/client';

type GetCompanyInvoicingContactQueryVariables = {
  companyId: number;
};

export type GetCompanyInvoicingContactQuery = {
  orders_companies_by_pk: {
    data?: {
      invoicing_contact?: string;
    };
  };
};

export const getCompanyInvoicingContactQuery = gql`
  query getCompanyInvoicingContact($companyId: bigint!) {
    orders_companies_by_pk(id: $companyId) {
      id
      data
    }
  }
` as TypedDocumentNode<
  GetCompanyInvoicingContactQuery,
  GetCompanyInvoicingContactQueryVariables
>;
